exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[result-content] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n[result-content] mdl-icon {\n  font-size: 20px;\n  padding-right: 10px;\n}\n\n", ""]);

// exports
